"use strict";
import { SharedEventName, SwapEventName } from "@uniswap/analytics-events";
import { ExtensionEventName } from "features/telemetry/constants/extension";
import { UniswapEventName } from "features/telemetry/constants/uniswap";
export var WalletEventName = /* @__PURE__ */ ((WalletEventName2) => {
  WalletEventName2["AppRating"] = "App Rating";
  WalletEventName2["BackupMethodAdded"] = "Backup Method Added";
  WalletEventName2["BackupMethodRemoved"] = "Backup Method Removed";
  WalletEventName2["DappRequestCardClosed"] = "DappRequestCardClosed";
  WalletEventName2["DappRequestCardPressed"] = "DappRequestCardPressed";
  WalletEventName2["ExploreSearchCancel"] = "Explore Search Cancel";
  WalletEventName2["ExternalLinkOpened"] = "External Link Opened";
  WalletEventName2["GasEstimateAccuracy"] = "Gas Estimate Accuracy";
  WalletEventName2["KeyringMissingMnemonic"] = "Keyring Missing Mnemonic";
  WalletEventName2["ModalClosed"] = "Modal Closed";
  WalletEventName2["NFTVisibilityChanged"] = "NFT Visibility Changed";
  WalletEventName2["NFTsLoaded"] = "NFTs Loaded";
  WalletEventName2["NetworkFilterSelected"] = "Network Filter Selected";
  WalletEventName2["OnboardingIntroCardClosed"] = "Onboarding Intro Card Closed";
  WalletEventName2["OnboardingIntroCardPressed"] = "Onboarding Intro Card Pressed";
  WalletEventName2["OnboardingIntroCardSwiped"] = "Onboarding Intro Card Swiped";
  WalletEventName2["PendingTransactionTimeout"] = "Pending Transaction Timeout";
  WalletEventName2["PerformanceGraphql"] = "Performance GraphQL";
  WalletEventName2["PortfolioBalanceFreshnessLag"] = "Portfolio Balance Freshness Lag";
  WalletEventName2["SendRecipientSelected"] = "Send Recipient Selected";
  WalletEventName2["ShareButtonClicked"] = "Share Button Clicked";
  WalletEventName2["SwapSubmitted"] = "Swap Submitted to Provider";
  WalletEventName2["TestnetEvent"] = "Testnet Event";
  WalletEventName2["TestnetModeToggled"] = "Testnet Mode Toggled";
  WalletEventName2["TokenVisibilityChanged"] = "Token Visibility Changed";
  WalletEventName2["TransferCompleted"] = "Transfer Completed";
  WalletEventName2["TransferSubmitted"] = "Transfer Submitted";
  WalletEventName2["ViewRecoveryPhrase"] = "View Recovery Phrase";
  WalletEventName2["WalletAdded"] = "Wallet Added";
  WalletEventName2["WalletRemoved"] = "Wallet Removed";
  return WalletEventName2;
})(WalletEventName || {});
export const WALLET_TESTNET_CONFIG = {
  allowlistEvents: [
    SharedEventName.PAGE_VIEWED,
    SharedEventName.ELEMENT_CLICKED,
    UniswapEventName.TokenSelected,
    "External Link Opened" /* ExternalLinkOpened */,
    "Network Filter Selected" /* NetworkFilterSelected */,
    "Swap Submitted to Provider" /* SwapSubmitted */,
    "Transfer Completed" /* TransferCompleted */,
    "Transfer Submitted" /* TransferSubmitted */,
    SwapEventName.SWAP_SUBMITTED_BUTTON_CLICKED,
    SwapEventName.SWAP_TRANSACTION_COMPLETED,
    SwapEventName.SWAP_TRANSACTION_FAILED,
    SwapEventName.SWAP_QUOTE_RECEIVED,
    ExtensionEventName.DappChangeChain,
    ExtensionEventName.DappRequest
  ],
  passthroughAllowlistEvents: [
    ExtensionEventName.DappConnect,
    ExtensionEventName.DappDisconnect,
    ExtensionEventName.DappDisconnectAll,
    ExtensionEventName.DappTroubleConnecting
  ],
  aggregateEventName: "Testnet Event" /* TestnetEvent */
};
